/**
 * @generated SignedSource<<8457e3c5a8b7d8596e34b1fd8f3582d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGetCanClientFulFillRequests_facility$data = {
  readonly club: {
    readonly supportsPublic: boolean;
  } | null | undefined;
  readonly privateBookingPermissionSet: {
    readonly clientCanFulfillRequests: boolean | null | undefined;
  } | null | undefined;
  readonly publicBookingPermissionSet: {
    readonly clientCanFulfillRequests: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useGetCanClientFulFillRequests_facility";
};
export type useGetCanClientFulFillRequests_facility$key = {
  readonly " $data"?: useGetCanClientFulFillRequests_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetCanClientFulFillRequests_facility">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "clientCanFulfillRequests",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetCanClientFulFillRequests_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "supportsPublic",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PrivateBookingPermissionSet",
      "kind": "LinkedField",
      "name": "privateBookingPermissionSet",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PublicBookingPermissionSet",
      "kind": "LinkedField",
      "name": "publicBookingPermissionSet",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};
})();

(node as any).hash = "b1ffc4a6a3256ddb38ba2e532e5db821";

export default node;
